module.exports = __webpack_public_path__ + "static/media/oero-loader.add6871b.png";